import moment from "moment-timezone";

export default {
    data() {
        return {
            cabinetUnitPrice: 0.55,
        };
    },
    methods: {
        formatNumberToCurrency(number) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(number);
        },
        feesAccrued(receiptLog, receiptLogUnit, hypotheticalDeliveryDate) {
            let fees = 0;
            switch (receiptLog.materialType.description) {
                case "Cabinets":
                    fees = this.cabinetFees(
                        receiptLog,
                        hypotheticalDeliveryDate,
                    );
                    break;
                case "Furniture":
                    fees = this.furnitureFees(
                        receiptLog,
                        receiptLogUnit,
                        hypotheticalDeliveryDate,
                    );
                    break;
                default:
                    fees = 0;
            }
            return fees;
        },
        feesAccruedFormatted(
            receiptLog,
            receiptLogUnit,
            hypotheticalDeliveryDate,
        ) {
            const fees = this.feesAccrued(
                receiptLog,
                receiptLogUnit,
                hypotheticalDeliveryDate,
            );
            return this.formatNumberToCurrency(fees);
        },
        storageStart(receiptLog, receiptLogUnit) {
            if (!receiptLog || !receiptLogUnit) return null;
            const freeStorageDays = receiptLog?.materialType?.freeStorageDays;
            if (freeStorageDays) {
                // don't start the day it was received, but the day after
                const freeDayUponReceipt = 1;
                return moment(receiptLogUnit.date).add(
                    freeStorageDays + freeDayUponReceipt,
                    "days",
                );
            }
            return null;
        },
        dailyCabinetRate(receiptLog) {
            return this.cabinetUnitPrice * receiptLog.size;
        },
        dailyFurnitureRateFormatted() {
            return "$0.10 / sqft.";
        },
        dailyCabinetRateFormatted(receiptLog) {
            if (!receiptLog) return `# of cabinets * $${this.cabinetUnitPrice}`;
            const rate = this.formatNumberToCurrency(
                this.dailyCabinetRate(receiptLog),
            );
            return `${receiptLog.size} cabinets * $${this.cabinetUnitPrice} = ${rate}`;
        },
        cabinetFees(receiptLog, hypotheticalDeliveryDate) {
            const receiptLogUnit = receiptLog.units[0];
            const start = this.storageStart(receiptLog, receiptLogUnit);
            if (start) {
                const today = moment();
                // get the date it was delivered if there is one
                const deliveryDate = receiptLogUnit.deliveryLog?.date
                    ? moment(receiptLogUnit.deliveryLog?.date)
                    : null;
                // first use actual delivery date, then hypothetical delivery date, then today
                const compareDate =
                    deliveryDate || moment(hypotheticalDeliveryDate) || today;
                if (compareDate > start) {
                    const inclusiveStart = 1;
                    const days =
                        Math.floor(compareDate.diff(start, "days", true)) +
                        inclusiveStart;
                    return days * this.dailyCabinetRate(receiptLog);
                }
                return 0;
            }
            return 0;
        },
        furnitureFees(receiptLog, receiptLogUnit, hypotheticalDeliveryDate) {
            let receiptLogUnits = [];
            if (receiptLogUnit) {
                receiptLogUnits.push(receiptLogUnit);
            } else {
                receiptLogUnits = [...receiptLog.units];
            }
            if (!receiptLogUnits.length) return 0;
            return (
                receiptLogUnits
                    .map((unit) => {
                        const start = this.storageStart(receiptLog, unit);
                        if (start) {
                            const today = moment();
                            // get the date it was delivered if there is one
                            const deliveryDate = unit.deliveryLog?.date
                                ? moment(unit.deliveryLog?.date)
                                : null;
                            // first use actual delivery date, then hypothetical delivery date, then today
                            const compareDate =
                                deliveryDate ||
                                moment(hypotheticalDeliveryDate) ||
                                today;
                            if (compareDate > start) {
                                const inclusiveStart = 1;
                                const days =
                                    Math.floor(
                                        compareDate.diff(start, "days", true),
                                    ) + inclusiveStart;
                                const dailyRate =
                                    ((unit.length * unit.width) / 144) * 0.1;
                                return days * dailyRate;
                            }
                        }
                        return 0;
                    })
                    .reduce((a, b) => a + b) || 0
            );
        },
    },
};
